// extracted by mini-css-extract-plugin
export var attribution = "_ba-4";
export var authorName = "_ba-5";
export var quote = "_ba-3";
export var testimonial = "_ba-2";
export var trustedBy = "_ba-0";
export var trustedByLabel = "_ba-1";